module.exports = __webpack_public_path__ + "img/usc.a0d924d8.svg";